import React, { useEffect, useState } from "react";
import './nav.css'
import {FiMenu, FiX, FiSun, FiMoon} from "react-icons/fi"
import CV from "../../assets/luis_1.3.pdf"
import { profile } from "../../data/profile";

const links = [
    { href: '#about', label: 'About' },
    { href: '#experience', label: 'Experience' },
    { href: '#portfolio', label: 'Projects' },
    { href: '#skills', label: 'Skills' },
    { href: '#contact', label: 'Contact' }
]

const getInitialTheme = () => {
    const attr = document.documentElement.getAttribute('data-theme')
    if (attr) return attr
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

const Nav = () => {
    const [activeNav, setActiveNav] = useState('')
    const [menuOpen, setMenuOpen] = useState(false)
    const [theme, setTheme] = useState(getInitialTheme)

    // Highlight the link for the section currently in view.
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) setActiveNav(`#${entry.target.id}`)
            })
        }, { rootMargin: '-40% 0px -55% 0px' })

        links.forEach(({ href }) => {
            const el = document.querySelector(href)
            if (el) observer.observe(el)
        })
        return () => observer.disconnect()
    }, [])

    const toggleTheme = () => {
        const next = theme === 'dark' ? 'light' : 'dark'
        document.documentElement.setAttribute('data-theme', next)
        try { localStorage.setItem('theme', next) } catch (e) {}
        setTheme(next)
    }

    return(
        <nav className="nav">
            <div className="container nav__container">
                <a href="#top" className="nav__brand" onClick={() => setMenuOpen(false)}>{profile.name}</a>

                <ul className={menuOpen ? 'nav__links open' : 'nav__links'}>
                    {links.map(({ href, label }) => (
                        <li key={href}>
                            <a href={href}
                            onClick={() => setMenuOpen(false)}
                            className={activeNav === href ? 'active' : ''}>{label}</a>
                        </li>
                    ))}
                    <li>
                        <a href={CV} download className="btn btn-primary nav__cv">Resume</a>
                    </li>
                </ul>

                <div className="nav__actions">
                    <button className="nav__icon-btn" onClick={toggleTheme}
                    aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}>
                        {theme === 'dark' ? <FiSun/> : <FiMoon/>}
                    </button>
                    <button className="nav__icon-btn nav__menu-btn" onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu" aria-expanded={menuOpen}>
                        {menuOpen ? <FiX/> : <FiMenu/>}
                    </button>
                </div>
            </div>
        </nav>
    )
}

export default Nav
